import { useQuery } from '@tanstack/react-query'

import { TAgentPhoneSettings } from '~/features/agents/models'
import { queryKeys } from '~/features/agents/utils'
import { EServerPath } from '~/models/api'
import HttpService from '~/services/http'
import pathBuilder from '~/utils/api'

const useGetAgentPhoneSettings = (agentId: string) => {
  return useQuery({
    enabled: !!agentId,
    queryKey: queryKeys.agentPhoneSettings(agentId),
    queryFn: () =>
      HttpService.get<TAgentPhoneSettings>({
        path: pathBuilder(EServerPath.agentPhoneSettings, { agentId }),
      }),
  })
}

export default useGetAgentPhoneSettings
